var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.95777 5.69902L0.913415 3.65467C0.811763 3.55649 0.675615 3.50216 0.534296 3.50339C0.392978 3.50462 0.257795 3.5613 0.157864 3.66123C0.0579323 3.76116 0.0012484 3.89635 2.03749e-05 4.03767C-0.00120765 4.17898 0.0531185 4.31513 0.151298 4.41678L2.57671 6.8422C2.67778 6.94324 2.81485 7 2.95777 7C3.10068 7 3.23775 6.94324 3.33882 6.8422L9.2676 0.913416C9.36578 0.811763 9.42011 0.675615 9.41888 0.534297C9.41765 0.392978 9.36097 0.257795 9.26104 0.157864C9.16111 0.0579325 9.02592 0.0012484 8.8846 2.03748e-05C8.74329 -0.00120765 8.60714 0.0531187 8.50548 0.151298L2.95777 5.69902Z",
    fill: "#49CC90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.cedfb58104869804508b380a94ad8536.svg";
export { ForwardRef as ReactComponent };